export default __webpack_public_path__ + "8d54792c7f68fbf5ef835be859433af8.png";